module.exports = __webpack_public_path__ + "img/ballantines-footer-logo.8b54c87d.svg";